import { render, staticRenderFns } from "./yumnow.vue?vue&type=template&id=2e7885f2&scoped=true&"
import script from "./yumnow.vue?vue&type=script&lang=js&"
export * from "./yumnow.vue?vue&type=script&lang=js&"
import style0 from "./yumnow.vue?vue&type=style&index=0&id=2e7885f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7885f2",
  null
  
)

export default component.exports